<div class="main">
    <header class="main-header">
        <h1>{pageTitle}</h1>
        <div class="main-options">
            {#if showPageOptions}
                <button type="button" class="main-option export" on:click={onExportEportfolioClick}>
                    <span>{terms.export}</span>
                </button>
                <button type="button" class="main-option global-settings" on:click={showEPortfolioSettings}>
                    <span>{terms.globalSettings}</span>
                </button>
            {/if}
        </div>
    </header>
    {#if canEdit && urls.publicAccess}
        {#if shareDialogVisible}
            <ShareDialog bind:this={shareDialog} publicUrl={urls.publicAccess} terms={terms.shareDialogTerms} on:modalClosed={closeShareDialog} />
        {/if}
    {/if}

    <aside class="aside">
        {#if canEdit}
            <EPortfolioOwnerInlineEditor 
                {owner}
                {urls}
                {terms}
                {nameMaxLength}
                {summaryMaxLength}
                {fileRepoSettings}
                {fileValidationSettings}
                {antiForgeryHeaderSettings}
                canEditEmail={ePortfolioSettings.emailEnable}
                on:showShareDialog={showShareDialog} />
        {:else}
            <ViewOwnerInformation {owner} {terms} canEdit={false} />
        {/if}
    </aside>
    {#if ePortfolioSettingsVisible}
        <div class="settings">
            <EPortfolioSettings
                terms={ePortfolioSettings.terms}
                settings={ePortfolioSettings.settings}
                accessLevels={ePortfolioSettings.accessLevels}
                saveSettingsUrl={urls.globalSettings}
                canChangeUseBlogSetting={ePortfolioSettings.canChangeUseBlogSetting}
                {antiForgeryHeaderSettings}
                on:saveEPortfolioSettings={onSaveEPortfolioSettings}
                on:closeEPortfolioSettings={onCloseEPortfolioSettings} />
        </div>
    {:else}
        <div class="portfolios">
            {#if canEdit}
                <Export
                    currentExportResult={exportSettings.exportResult}
                    exportUrl={exportSettings.exportUrl}
                    iconUrl={exportSettings.exportIconUrl}
                    terms={exportSettings.terms}
                    {antiForgeryHeaderSettings} />
            {/if}

            <ul class="portfolios-list">
                {#each portfolios as portfolio}
                    <li>
                        <a class="portfolio-link" href={portfolio.portfolioUrl} style="background-color: {portfolio.design.color}">
                            <header class="header" style="background-image: {portfolio.design && portfolio.design.bannerUrl ? `url("${portfolio.design.bannerUrl}")` : 'none'}">
                            </header>
                            <footer class="footer">
                                <span class="portfolio-title">{portfolio.title}</span>
                                {#if portfolio.unreadCommentsTitle}
                                    <div class="portfolio-new-comments-label">{portfolio.unreadCommentsTitle}</div>
                                {/if}
                            </footer>
                        </a>
                    </li>
                {/each}
                {#if urls && urls.addNewPortfolio}
                    <li class="add-portfolio">
                        <a class="add-portfolio-link" href={urls.addNewPortfolio}>
                            <footer class="footer">
                                <img class="add-portfolio-icon" src={icons.addPortfolio} alt="" />
                                <span>{terms.addNewPortfolio}</span>
                            </footer>
                        </a>
                    </li>
                {/if}
            </ul>
        </div>
    {/if}
</div>

<script>
    import { tick } from 'svelte';

    import ShareDialog from '@its-ui/eportfolio-common/ShareDialog/ShareDialog.svelte';
    import ViewOwnerInformation from '@its-ui/eportfolio-common/EPortfolioOwner/ViewOwnerInformation.svelte';
    import EPortfolioSettings from '@its-ui/eportfolio-common/ManageEPortfolio/ManageEPortfolio.svelte';
    import EPortfolioOwnerInlineEditor from '@its-ui/eportfolio-common/EPortfolioOwner/EPortfolioOwnerInlineEditor.svelte';
    import Export from '@its-ui/eportfolio-common/Export/Export.svelte';
    import { copyEPortfolioSettings, dispatchEvent } from '@its-ui/eportfolio-common/common';
    import { get } from '@itslearning/atlas/network/fetch';

    export let owner = {};
    export let portfolios = [];
    export let urls = {};
    export let terms = {};
    export let icons = {};
    export let antiForgeryHeaderSettings = {};
    export let fileRepoSettings = {};
    export let fileValidationSettings = {};
    export let canEdit = false;
    export let nameMaxLength = 0;
    export let summaryMaxLength = 0;
    export let shareDialogVisible = false;
    export let ePortfolioSettings = {};
    export let ePortfolioSettingsVisible = false;
    export let exportSettings = {};

    $: pageTitle = ePortfolioSettingsVisible ? terms.globalSettings : terms.ePortfolio;
    $: showPageOptions = canEdit && !ePortfolioSettingsVisible;

    let shareDialog;

    async function showShareDialog() {
        shareDialogVisible = true;
        await tick();
        shareDialog.focusCopyButton();
    }

    function closeShareDialog() {
        shareDialogVisible = false;
    }

    function showEPortfolioSettings() {
        ePortfolioSettingsVisible = true;
    }

    function refreshPortfolios() {
        get(urls.getPortfolios)
            .then(data => {
                portfolios = data;
            });
    }

    function onExportEportfolioClick() {
        dispatchEvent('startNewExport');
    }

    function onSaveEPortfolioSettings(event) {
        if (ePortfolioSettings.settings.useBlog !== event.detail.settings.useBlog) {
            refreshPortfolios();
        }

        ePortfolioSettings.settings = copyEPortfolioSettings(event.detail.settings);

        refreshExportResult();
        ePortfolioSettingsVisible = false;
    }

    function onCloseEPortfolioSettings() {
        refreshExportResult();
        ePortfolioSettingsVisible = false;
    }
    
    function refreshExportResult() {
        get(exportSettings.exportUrl)
            .then((newExportResult) => {
                exportSettings.exportResult = newExportResult;
                exportSettings = exportSettings;
            });
    }
</script>
